import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1.1, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "" }) => (
  <div className={`font-mono text-[11px] tracking-[0.25em] uppercase text-neutral-500 ${className}`}>
    {children}
  </div>
);

export const Frame = ({ num, section, children }) => (
  <div className="w-full h-full flex flex-col px-5 sm:px-16 lg:px-24 pt-10 sm:pt-14 pb-24 sm:pb-28 overflow-hidden">
    <Reveal className="flex items-center gap-4 sm:gap-6 border-b border-neutral-800 pb-3 sm:pb-4">
      <span className="font-mono text-[11px] tracking-[0.3em] text-[#dd6611]">{num}</span>
      <Label>{section}</Label>
      <div className="flex-1" />
      <Label className="hidden sm:block">Averra Life — Go-to-Market</Label>
    </Reveal>
    <div className="flex-1 min-h-0 overflow-y-auto py-4 flex flex-col">
      <div className="my-auto w-full">{children}</div>
    </div>
  </div>
);

export const Headline = ({ children, delay = 0.15, className = "" }) => (
  <Reveal delay={delay}>
    <h1 className={`text-2xl sm:text-4xl lg:text-5xl font-light tracking-tight text-white leading-[1.15] sm:leading-[1.1] max-w-4xl ${className}`}>
      {children}
    </h1>
  </Reveal>
);

export const Cell = ({ title, sub, accent, className = "" }) => (
  <div className={`border border-neutral-800 p-5 ${className}`}>
    <div className={`text-base sm:text-lg font-normal ${accent ? "text-[#dd6611]" : "text-white"}`}>
      {title}
    </div>
    {sub && <div className="font-mono text-[10px] tracking-[0.15em] uppercase text-neutral-500 mt-2">{sub}</div>}
  </div>
);

export const Arrow = ({ className = "" }) => (
  <span className={`text-[#dd6611] font-mono ${className}`}>→</span>
);
